<template>
  <div>
    <div v-if="render">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  delay: {
    type: Number,
    default: 200
  },
  threshold: {
    type: Number,
    default: 0.1
  },
  rootMargin: {
    type: String,
    default: '0px'
  },
  visibilityBased: {
    type: Boolean,
    default: false
  }
});

const render = ref(false);

onMounted(() => {
  if (props.visibilityBased) {
    // Set up intersection observer for visibility-based loading
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setTimeout(() => {
            render.value = true;
          }, props.delay);
          observer.disconnect();
        }
      },
      {
        threshold: props.threshold,
        rootMargin: props.rootMargin
      }
    );
    observer.observe(document.querySelector('div'));
  } else {
    // Use setTimeout for simple delay-based loading
    setTimeout(() => {
      render.value = true;
    }, props.delay);
  }
});
</script>